import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cc994eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative space-y-2 select-border" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = {
  key: 0,
  class: "flex-grow flex-shrink flex flex-wrap items-center mt-1 pl-2 min-w-0"
}
const _hoisted_4 = ["placeholder"]

import {ref, watch} from 'vue';
import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition.vue";

import {Option} from "@/types/LevelsSelectTypes/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'LevelsSelect',
  props: {
    options: {},
    modelValue: {},
    placeholder: {},
    limit: {},
    open: { type: Boolean }
  },
  emits: ["selectOption", "update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const dropdownOpen = ref(props.open ?? false)
const searching = ref(props.open ?? false)
const search = ref('')
const placeholder = ref(props.placeholder)
const expanded = ref<any>([]);
const options = ref<Option[]>(props.options);
const toggleDropdown = (event: any) => {
  if (event) {
    event.stopPropagation()
  }
  if (!props.open) {

    dropdownOpen.value = !dropdownOpen.value;

  } else {
    dropdownOpen.value = true;
    searching.value = true;
  }
};
const findElement = (): Option | undefined | null => {
  for (const option of props.options) {
    const foundOption = findOptionByIdRecursive(option, props.modelValue);
    if (foundOption) {
      return foundOption;
    }
  }

}
const close = () => {
  if (!props.open) {
    dropdownOpen.value = false;
  }
  searching.value = false;
  search.value = '';
  placeholder.value = selectedOption.value?.label ?? props.placeholder;
};
const selectedOption = ref<Option | undefined | null>(findElement());

function findOptionByIdRecursive(option: Option, optionId: any): Option {
  if (option.id === optionId) {
    return option;
  }
  if (!option.options || option.options.length == 0) {
    return null as any;
  }
  for (const subCategory of option.options) {
    const foundOption = findOptionByIdRecursive(subCategory, optionId);
    if (foundOption) {
      return foundOption;
    }
  }

  return null as any;
}


const selectOption = (event: any, option: Option) => {
  if (Array.isArray(event)) {
    if (!option) {
      option = event[1];
    }
    event = event[0]

  }
  event.stopPropagation()
  if (event.pointerId == 1) {

    emit("selectOption", [event, option?.id == props.modelValue ? null : option]);
    emit("update:modelValue", option?.id == props.modelValue ? null : option?.id);
    selectedOption.value = option?.id == props.modelValue ? null : option;

    if (selectedOption.value) {
      close()
    }
  }
  placeholder.value = selectedOption.value?.label ?? props.placeholder;

};
const getExpandedDeep = (option: Option): void => {
  if (option) {
    expanded.value.push(option.id)
  }
};

const getParentIdsDeep = (options: Option[], targetId: any): any[] | null => {
  const findParentIds = (currentOptions: Option[], currentId: number, parentIds: any[]): any[] | null => {
    for (const option of currentOptions) {
      const updatedParentIds = [...parentIds, option.id];

      if (option.id === currentId) {
        // If the target ID is found and it is not the top-level ancestor, return parent IDs
        return parentIds.length > 0 ? updatedParentIds.filter((id) => id !== targetId) : [];
      }

      if (option.options && option.options.length > 0) {
        const result = findParentIds(option.options, currentId, updatedParentIds);
        if (result !== null) {
          return result;
        }
      }
    }

    return null;
  };

  return findParentIds(options, targetId, []);
};
// Example usage
const getOptions = (): Option[] => {

  const limitedOptions: Option[] = props.options.slice(0, props.limit ? props.limit + 1 : 5);
  let option: Option = null as any;

  if (expanded.value && expanded.value.length > 0) {
    option = props.options.find((option) => expanded.value.includes(option.id)) as any;
  } else if (selectedOption.value?.parent_id == null) {
    option = props.options.find((option) => option.id == selectedOption.value?.id) as any;
  }

  if (option) {
    return limitedOptions.concat(option).filter((item, index, self) =>
      self.findIndex((t) => t.id === item.id) === index
    );
  }

  return limitedOptions;

};

if (props.open) {
  expanded.value = getParentIdsDeep(props.options, selectedOption.value?.id);
  searching.value = true
  placeholder.value = selectedOption.value?.label ?? props.placeholder;
}
watch(() => dropdownOpen.value, (newValue) => {
  if (newValue) {
    expanded.value = getParentIdsDeep(props.options, selectedOption.value?.id);
    searching.value = true
    placeholder.value = selectedOption.value?.label ?? props.placeholder;


  } else {
    close()
  }

}, {deep: true});
watch(() => expanded.value, (newValue) => {
  if (search.value.length == 0) {
    options.value = getOptions();
  }
}, {deep: true});
const filterRecursive = (options: Option[], search: string): Option[] => {
  const filteredOptions: Option[] = [];
  for (const option of options) {
    if (option.label.toLowerCase().includes(search.toLowerCase())) {
      filteredOptions.push(option)
      filteredOptions.filter((item, index, self) =>
        self.findIndex((t) => t.id === item.id) === index
      );
    }

    if (option.options && option.options.length > 0) {
      const filteredSubOptions = filterRecursive(option.options, search);
      if (filteredSubOptions.length > 0) {
        filteredOptions.push({
          ...option,
          options: filteredSubOptions.filter((item, index, self) =>
            self.findIndex((t) => t.id === item.id) === index
          ),
        });
      }
    }
  }

  return filteredOptions;
};
watch(() => search.value, (newValue) => {
  if (newValue.length > 0) {
    searching.value = true
    options.value = filterRecursive(props.options, newValue);
  } else {
    options.value = getOptions();
  }
}, {deep: true});


return (_ctx: any,_cache: any) => {
  const _component_levels_select_list = _resolveComponent("levels-select-list")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = _withModifiers((event)=>toggleDropdown(event), ["stop"])),
      class: "w-full z-9 relative box-border cursor-pointer border border-gray-300 dark:border-gray-500 rounded bg-white dark:bg-opacity-5 text-base leading-snug outline-none min-h-10"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (selectedOption.value && !searching.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(selectedOption.value?.label), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              onClick: _cache[0] || (_cache[0] = _withModifiers((event)=>dropdownOpen.value=true, ["stop"])),
              class: "w-full border-none bg-opacity-0 rounded bg-white text-base outline-none h-10 pl-2 placeholder:pl-2",
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
              placeholder: placeholder.value
            }, null, 8, _hoisted_4)), [
              [_vModelText, search.value]
            ])
      ]),
      (!_ctx.open)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["levels-select-caret bg-center bg-no-repeat w-2.5 h-4 py-px box-content mr-3.5 relative z-10 opacity-40 flex-shrink-0 flex-grow-0 transition-transform transform pointer-events-none rtl:mr-0 rtl:ml-3.5", { 'rotate-180': dropdownOpen.value }])
          }, null, 2))
        : _createCommentVNode("", true)
    ]),
    _createVNode(CollapseTransition, null, {
      default: _withCtx(() => [
        (dropdownOpen.value)
          ? (_openBlock(), _createBlock(_component_levels_select_list, {
              key: 0,
              class: "px-2 py-2 z-9 dark:bg-dark select-list absolute border",
              onSelectOption: selectOption,
              options: options.value,
              expanded: expanded.value,
              selectedOption: selectedOption.value
            }, null, 8, ["options", "expanded", "selectedOption"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ])), [
    [_directive_click_outside, close]
  ])
}
}

})